export default {
  head () {
    return {
      script: [
        { src: '/assets/js/onesignal.js' },
      ],
    }
  },

  mounted() {
    window.ONESIGNAL_APPID = process.env.ONESIGNAL_APPID;
    window.ONESIGNAL_SAFARI_WEBID = process.env.ONESIGNAL_SAFARI_WEBID
  }
}
